module.exports = __webpack_public_path__ + "img/header_phones.1b39ed44.jpg";